import * as React from "react";
import { Navigation, NavigationSelectedPage } from "../components/Navigation";
import "./DefaultLayout.css";
import { AppControlHeader } from "../components/AppControlHeader";
import { Header } from "../components/HeaderComponent";
import { LoadingOverlay, Notification, Support } from "@components";
import { History, Location } from "history";
import * as cn from "classnames";

export interface DefaultLayoutProps {
    children?: React.ReactChild | React.ReactChild[];
    asideChildren?: () => React.ReactChild | React.ReactChild[];
    loading?: boolean;
    loadingFailed?: boolean;
    selectedPage?: NavigationSelectedPage;
    history?: History;
    location?: Location;
    isEditCampaignPage?: boolean;
    clientId: string;
    disableContent: boolean;
}

export interface DefaultLayoutState {
    isMobileScreen: boolean;
    isAsideContentOpen: boolean;
}

export class DefaultLayout extends React.Component<DefaultLayoutProps, DefaultLayoutState> {
    constructor(props: DefaultLayoutProps) {
        super(props);
        this.state = {
            isMobileScreen: false,
            isAsideContentOpen: false
        };
        this.updateScreenState = this.updateScreenState.bind(this);
    }

    componentDidMount() {
        this.updateScreenState();
        window.addEventListener("resize", this.updateScreenState);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateScreenState);
    }

    updateScreenState() {
        this.setState({ isMobileScreen: window.innerWidth > 768 ? false : true });
    }

    updateAsideContentState() {
        this.setState({ isAsideContentOpen: !this.state.isAsideContentOpen });
    }

    render() {
        const {
            disableContent,
            children,
            asideChildren,
            loading,
            selectedPage,
            history,
            location,
            loadingFailed,
            isEditCampaignPage,
            clientId
        } = this.props;
        const { isAsideContentOpen, isMobileScreen } = this.state;

        return (
            <div className={cn("DefaultLayout", isAsideContentOpen ? "aside-open" : "")}>
                <aside className="DefaultLayout__nav-menu">
                    <Navigation clientId={clientId} selectedPage={selectedPage} />
                </aside>
                {!disableContent && (
                    <AppControlHeader
                        history={history}
                        location={location}
                        className="DefaultLayout__aside-top"
                        selectedPage={selectedPage}
                        clientId={clientId}
                        isMobileScreen={isMobileScreen}
                        updateAsideContentState={this.updateAsideContentState.bind(this)}
                        isAsideContentOpen={isAsideContentOpen}
                    />
                )}
                <section className="DefaultLayout__aside-content">
                    <LoadingOverlay
                        loading={loading}
                        loadingFailed={loadingFailed}
                        className="DefaultLayout__loading-indicator"
                        isAsideOverlay={true}
                    >
                        {asideChildren && !disableContent && asideChildren()}
                    </LoadingOverlay>
                </section>
                <Header
                    className="DefaultLayout__app-header"
                    clientId={clientId}
                    isEditCampaignPage={isEditCampaignPage}
                    history={history}
                    location={location}
                    isMobileScreen={isMobileScreen}
                />
                <main className="DefaultLayout__content">
                    {
                        <LoadingOverlay
                            loading={loading}
                            loadingFailed={loadingFailed}
                            className="DefaultLayout__loading-indicator"
                        >
                            {disableContent ? null : children}
                        </LoadingOverlay>
                    }
                </main>
                <Notification />
                <Support />
            </div>
        );
    }
}
